import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function PartnersSlider({ partners }) {


  const settings = {
    dots: true,              // pagination
    arrows: false,           // pas de flèches
    infinite: true,          // loop
    autoplay: true,          // autoplay activé
    autoplaySpeed: 2500,     // délai entre les slides
    speed: 800,              // durée de l’animation
    slidesToShow: 4,         // desktop
    slidesToScroll: 1,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,    // tablettes
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,     // mobiles larges
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,     // petits mobiles
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };

  return (
    <div className="partner-slider mb-5">
      <Slider {...settings}>
        { partners.map((item, idx) => (
          <div key={ idx } className="px-3 h-100">
            <div className="partner-card border rounded-3 gap-2 shadow-sm p-4 h-100 d-flex flex-column align-items-center">
              <img src={item.icon} alt="icon-agrospace" width="60" />
              <span className="text-center text-muted fw-bold">{ item.title }</span>
              <span className="text-center text-muted">{ item.desc }</span>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}
